module.exports = __webpack_public_path__ + "img/img_37@2x.b3f3aece.png";